import React, { useCallback, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";
import eye from "assets/images/ct/they-know-eye.png";
import line from "assets/images/ct/question/que-line.png";
import dice from "assets/images/ct/question/dice-arrow.png";
import dicesketch1 from "assets/images/ct/dice-sketch1.png";
import dice1 from "assets/images/ct/dice1.png";
import dice2 from "assets/images/ct/dice2.png";
import dice3 from "assets/images/ct/dice3.png";
import dice4 from "assets/images/ct/dice4.png";
import dice5 from "assets/images/ct/dice5.png";
import dice6 from "assets/images/ct/dice6.png";
import dicearrow from "assets/images/ct/dice-arrow.png";

import checkIcon from "assets/images/ct/question/check-icon.png";
import {
  divVariants,
  fadeVariants,
  slide_bounce_down_variants,
  staticBounceVariants
} from "shared/components/animations";
const ActivePlayerQuestion = ({
  answers,
  category,
  currentPlayer,
  roomId,
  dicedata,screens
}) => {
  const [selectedOption, setSelectedOption] = useState("");

  const instructions = _.get(
    screens,
    "4_question.active.instructions",   
"Listen to the interrogator, answer their question. Got it?"
  );


  const optionAction = () => {

    if (selectedOption !=="") {
      const data = {
        action: "submit-answer",
        roomId,
        playerId: currentPlayer?.player_id,
        answer: selectedOption
      };

     Socket.sendMessage(data);
    }
  };
  const handleConfirmClick = useCallback(
    _.debounce(() => optionAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [selectedOption, currentPlayer]
  );
  const handleOptionClick = (item) => {

    setSelectedOption(item);

  };
  const diceValue = (type) => {
    switch (type) {
      case 1:
        return dice1;

      case 2:
        return dice2;
      case 3:
        return dice3;
      case 4:
        return dice4;
      case 5:
        return dice5;

      default:
        return dice6;
    }
  };

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="ct-question"
    >
      <motion.div variants={fadeVariants} className="ct-question-type">
        <img src={eye} className="img-fluid" alt="" />
        <div className="type">
          <h2>{category}</h2>
          <img src={line} className="img-fluid underline" alt="" />
        </div>
        <div className="dice">
          <img src={diceValue(dicedata?.dice[0])} alt="dicesketch" />
          <img src={diceValue(dicedata?.dice[1])} alt="dicesketch" />
          <img src={dicearrow} className="dice-arrow" alt="dicearrow" />
        </div>
      </motion.div>
      <motion.p variants={fadeVariants} className="question">
      {instructions}
      </motion.p>
      <motion.div
        variants={slide_bounce_down_variants}
        className="options-wrapper"
      >
        <div className="option-type">
          <div className="green-bg">
            <h2>{category}</h2>
          </div>
        </div>
        <div className="options-card">
          {answers?.map((value, key) => (
            <div
              className={`option-flex ${
                selectedOption === key ? "selected" : ""
              }`}
              key={value}
              onClick={() => handleOptionClick(key)}
            >
              <div className="check-box">
                {selectedOption === key && (
                  <img src={checkIcon} className="img-fluid icon" alt="" />
                )}
              </div>
              <div className="option-box">
                <div className="option-box-bg1">
                  <p className="mb-0">{value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div variants={staticBounceVariants} className="text-right">
        <button
          className="ct-btn-green px-5 confirm-btn"
          onClick={handleConfirmClick}
          style={{
            width: "auto",
            padding: "8px 18px 10px 18px",
            fontSize: "16px"
          }}
        >
          confirm
        </button>
      </motion.div>
    </motion.div>
  );
};

export default ActivePlayerQuestion;
